<template>
  <v-container grid-list-md class="unregister-container">
    <form action="/unregister" method="POST" ref="unregisterForm">
      <input type="hidden" name="_token" :value="csrfToken">
      <v-layout row wrap>
        <v-flex xs12 md8 class="card-wrapper">
          <div class="unregister-card">
            <div class="unregister-card-header">
              <h2>会員退会</h2>
            </div>
            <div class="unregister-card-body">
              <p class="summary">
                会員退会処理を行います。
              </p>

              <div class="unregister-list">
                <ul>
                  <li>会員情報が削除されます。</li>
                </ul>
              </div>

              <v-layout row v-if="isAdmin">
                <v-flex xs12>
                  <div class="form-group unregister-radio-group">
                    <v-radio-group
                      row
                      name="with_children"
                      required
                      :error-messages="errorWithChildren"
                    >
                      <v-radio :value="unregisterWithChildren" label="招待済みの会員も退会する"></v-radio>
                      <v-radio :value="unregisterWithoutChildren" label="招待済みの会員は「スタンダード会員」として利用を続ける"></v-radio>
                    </v-radio-group>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="isPersonal || !isAdmin">
                <v-flex xs12>
                  <p class="summary paid-txt" v-if="reasons.length != 0">退会の理由を選択してください（複数回答可、必須）</p>
                  <div>
                    <v-checkbox
                      name="withdrawal_reasons[]"
                      v-for="reason in reasons"
                      :key="reason.id"
                      :label="reason.reason"
                      :value="reason.id"
                      v-model="checkFlg"
                      required
                    ></v-checkbox>
                    <span class="error-message" role="alert" v-if="errorWithReason">
                      {{ errorWithReason }}
                    </span>
                    <br><br>
                    <v-textarea
                      name="other"
                      label="自由記入欄：その他退会事由について　今後の参考としたくご記載いただければ幸いです。（255文字以内でお願いします。）"
                      :value="messageValue"
                      :error-messages="errorWithMessage"
                      class="message-area"
                    ></v-textarea>
                  </div>
                </v-flex>
              </v-layout>
              <input type="hidden" name="reason_count" :value="reasons.length">
              <div class="text-xs-center">
                <v-btn type="button" color="error" flat @click="confirmUnregistration">
                  退会する
                </v-btn>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </form>
  </v-container>
</template>

<script>
  export default {
    props: [
      'errorWithChildren',
      'isAdmin',
      'reasons',
      'messageValue',
      'errorWithReason',
      'errorWithMessage',
      'isPersonal'
    ],

    data () {
      return {
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        unregisterWithChildren: 1,
        unregisterWithoutChildren: 2
      }
    },

    methods: {
      confirmUnregistration () {
        if (!confirm('退会処理を行います。よろしいですか？')) {
          return false
        }

        this.$refs.unregisterForm.submit()
        return true
      }
    }
  }
</script>

<style lang="scss">
  .unregister-radio-group .v-radio {
    margin-bottom: 20px;
  }
</style>

